module.exports = __webpack_public_path__ + "static/media/card-bronze.862b640f.png";